<div class="relative px-[1px]" (click)="onClick()" #proposition>
  <div
    *ngIf="item.isFlagged && showFlaggedOverlay"
    class="absolute top-0 left-0 right-0 bottom-0 z-[1] backdrop-blur-[5px]"
  >
    <div class="flex flex-col items-center translate-y-1/3 h-full">
      <ark-lib-icon-name name="flagged"></ark-lib-icon-name>
      <div class="w-full bg-pink-600 mt-[18px]">
        <div
          class="text-center text-white text-[11px] font-bold uppercase leading-[18px] tracking-wide"
        >
          Reported as illegal content
        </div>
      </div>
    </div>
  </div>

  <div
    class="p-5 flex flex-col border-solid poi cursor-pointer"
    [class.border-[2px]]="item.isModerated"
    [class.border-[#e5cc6f]]="item.isModerated"
    [class.bg-[#fff8e0]]="item.isModerated"
    [class.bg-white]="!item.isModerated"
    [class.opacity-40]="item.isFlagged && showFlaggedOverlay"
  >
    <div class="flex flex-col">
      <div
        #videoContainer
        class="-mx-5 aspect-[9/16] overflow-hidden rounded"
      >
        @if (item.video) {
          <ark-lib-plyr-video
            class="block w-full h-full rounded"
            (click)="$event.stopPropagation()"
            [videoUrl]="item.video"
            [autoplayOnViewport]="enableCenteredVideoAutoplay"
            [showThumbnail]="false"
            [preloadOnNearViewport]="enableCenteredVideoAutoplay"
            [options]="{ loop: 1, mute: 1 }"
            [fallbackThumbnail]="
              item.videoThumbnailUrl ??
              item.videoThumbnail ??
              (item.images | first)?.image ??
              '/assets/shared/images/placeholder-image.png'
            "
          ></ark-lib-plyr-video>
        } @else {
          <img
            class="w-full h-full rounded object-cover"
            [src]="
              (item.images | first)?.image ??
              '/assets/shared/images/placeholder-image.png'
            "
          />
        }
      </div>
      <div
        class="mt-[5px] flex items-center justify-between uppercase text-[11px]"
      >
        <div class="font-bold">
          {{ getItemTypeLabel(item) }}
        </div>
        <div class="text-[#BEB9B4] font-semibold" *ngIf="!item.isDraft && getItemIdentifier(item) !== null">
         #{{ getItemIdentifier(item) }}
        </div>
      </div>
      <div
        class="text-slate-900 text-xl font-bold leading-7 mt-[10px] line-clamp-2"
        [innerHTML]="item.title"
      ></div>
    </div>

    <div class="flex items-center py-1">
      <div
        class="w-full h-[3px] bg-[#E6E1D7]"
        [class.bg-[#e5cc6f]]="item.isModerated"
        [class.flex-[1]]="item.isModerated"
      ></div>
      <div class="pl-[5px]" *ngIf="item.isModerated">
        <div
          class="flex items-center text-black text-[11px] font-bold uppercase leading-[18px] tracking-wide w-max"
        >
          <div class="text-[#e5cc6f]">
            {{ getItemTypeLabel(item) }} in moderation
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-between mt-[5px] h-[34px]">
      <div class="flex flex-row items-center justify-start gap-[5px]">
        <div
          class="text-left text-black text-[11px] font-medium leading-[18px] cursor-pointer"
          (click)="onNicknameClick($event)"
        >
          by {{ '@' + item.creatorNickname }}
        </div>
        <ark-lib-pi-badge
          [userIndex]="item?.userIndex"
          [userIndexDiff]="item?.userIndexDetails?.userIndexDiff"
          [userIndexAmbassador]="item?.userIndexDetails?.userIndexAmbassador"
          [userIndexCreator]="item?.userIndexDetails?.userIndexCreator"
          [userIndexHelper]="item?.userIndexDetails?.userIndexHelper"
          [clickable]="true"
        ></ark-lib-pi-badge>
      </div>
      <div>
        <ark-lib-wisee [marketSectors]="item.marketSectors"></ark-lib-wisee>
      </div>
    </div>

    @if (item.type !== 'idea' && item.type !== 'problem') {
      <div
        class="justify-start items-center gap-3 flex w-full bg-[#F8F8F7] border border-solid border-[#BEB9B4] rounded-[15px] h-[30px] px-[20px] mt-[5px]"
        [class.bg-[#fff8e0]]="item.isModerated"
        (click)="openStatsPopover($event)"
      >
        <div class="justify-between items-baseline gap-2.5 flex w-full">
          <div class="justify-center items-center gap-[3px] flex">
            <ark-lib-icon-name name="heart"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item.subscriberCount }}
            </div>
          </div>
          @if (item?.backedCount != null) {
            <div class="justify-center items-center gap-[3px] flex">
              <ark-lib-icon-name name="backing"></ark-lib-icon-name>
              <div class="text-black text-xs font-normal leading-tight">
                {{ item.backedCount }}
              </div>
            </div>
          }
          <div class="justify-center items-center gap-[3px] flex">
            <ark-lib-icon-name name="stats-star"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item.rating | number:'1.0-2' }}
            </div>
            <div
              class="font-normal text-[10px] leading-[18px] text-black self-start"
            >
              ({{item.ratingCount}})
            </div>
          </div>
          <div class="justify-center items-center gap-[3px] flex">
            <ark-lib-icon-name name="chat"></ark-lib-icon-name>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item.commentCount }}
            </div>
          </div>
          <!-- <div class="justify-center items-center gap-[3px] flex">
            <div
              class="w-4 h-4 pl-1 pr-[3px] pt-[3px] pb-1 rounded-[13px] border border-slate-900 justify-center items-center flex"
            >
              <ark-lib-icon-name
                name="check-circle"
                class="relative top-[1px]"
              ></ark-lib-icon-name>
            </div>
            <div class="text-black text-xs font-normal leading-tight">
              {{ item.averageCommitmentLevel }}%
            </div>
          </div> -->
          <!-- <div class="flex flex-row items-center">
            <ark-lib-icon-name name="stats"></ark-lib-icon-name>
            <div
              class="text-black text-[11px] font-normal leading-[18px] ml-[5px]"
            >
              {{ item?.receivedCount }}
            </div>
          </div> -->
          @if (item.shareCount != null) {
            <div class="flex flex-row items-center">
              <ark-lib-icon-name name="share"></ark-lib-icon-name>
              <div
                class="text-black text-[11px] font-normal leading-[18px] ml-[5px]"
              >
                {{ item?.shareCount }}
              </div>
            </div>
          }
        </div>
      </div>
    }

    <div
      class="text-[#636363] text-base font-normal leading-[21px] mt-3 mb-[5px] line-clamp-3"
      [innerHTML]="
        item.type === 'idea' || item.type === 'problem'
          ? item.description
          : useTeaserText
            ? item.teaser
            : item.description
      "
    ></div>

    <div class="flex flex-row justify-between mt-3">
      <ark-ui-vote-buttons [item]="item"> </ark-ui-vote-buttons>
      <!-- <div
        class="flex flex-row items-center -ml-[38px]"
        *ngIf="!item.isMine && !item.isRead"
      >
        <div class="text-slate-900 text-sm font-semibold leading-[21px] mr-0.5">
          More
        </div>
        <div class="text-black text-[11px] font-normal leading-[18px]">
          {{ '(' + cost !== null ? '(' + cost + ' pts)' : 'Loading...' }}
        </div>
      </div> -->

      @if (item.type == 'idea' || item.type == 'problem') {
        <div class="flex flex-row items-center">
          <ark-lib-icon-name name="chat"></ark-lib-icon-name>
          <div
            class="text-black text-[11px] font-normal leading-[18px] ml-[5px]"
          >
            {{ item?.commentCount }}
          </div>
        </div>
      }
      <button
        id="share-button"
        class="flex flex-row items-center"
        (click)="openShareModal($event)"
      >
        <ark-lib-icon-name name="share"></ark-lib-icon-name>
        <p class="font-normal text-[11px] leading-[18px] ml-[8px] self-center">
          Share
        </p>
      </button>
      @if (item.isMine && menuOptions.length > 0) {
        <div class="flex flex-row items-center">
          <ark-lib-proposition-menu
            [options]="menuOptions"
            [mine]="true"
          ></ark-lib-proposition-menu>
        </div>
      } @else if (
        item.type !== 'idea' &&
        item.type !== 'problem' &&
        menuOptions.length > 0
      ) {
        <div class="flex flex-row items-center">
          <ark-lib-proposition-menu
            [options]="menuOptions"
            [mine]="false"
          ></ark-lib-proposition-menu>
        </div>
      }
    </div>
  </div>
</div>
